import {EDITOR_TOGGLE_SIDEBAR,} from './constants';

export function toggleSidebar() {
  return {
    type: EDITOR_TOGGLE_SIDEBAR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EDITOR_TOGGLE_SIDEBAR:
      return {
        ...state,
        showSidebar: !state.showSidebar,
      };

    default:
      return state;
  }
}
